import 'babel-polyfill';
import 'typeface-roboto';
import React from 'react';
import ReactDOM from 'react-dom';
import history from './history';
import './react-table-defaults';
import './styles/index.css';
import JssProvider from 'react-jss/lib/JssProvider';
import {create} from 'jss';
import {createGenerateClassName, jssPreset} from '@material-ui/core/styles';
import registerServiceWorker from './registerServiceWorker';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';
import {routes} from './fuse-configs/fuseRoutesConfig';
import {FuseLayout, FuseTheme, FuseAuthorization} from '@fuse';
import MainToolbar from './main/MainToolbar';
import MainNavbarContent from './main/MainNavbarContent';
import MainNavbarHeader from './main/MainNavbarHeader';
import MainFooter from './main/MainFooter';
import ApiAuth from './main/ApiAuth';
import jssExtend from 'jss-extend'
import store from 'store';
import {library} from '@fortawesome/fontawesome-svg-core';
import {fas} from '@fortawesome/free-solid-svg-icons';
import PollingTool from "./main/PollingTool";
import UecareLoadingMask from "./components/UecareLoadingMask";
import UecareErrorDialog from "./components/UecareErrorDialog";

library.add(fas); // fas 載入所有免費的 font-awesome-icon

const jss = create({
    ...jssPreset(),
    plugins: [...jssPreset().plugins, jssExtend()]
});

jss.options.insertionPoint = document.getElementById('jss-insertion-point');
const generateClassName = createGenerateClassName();

ReactDOM.render(
    <JssProvider jss={jss} generateClassName={generateClassName}>
        <Provider store={store}>
            <ApiAuth>
                <Router history={history}>
                    <FuseAuthorization routes={routes}>
                        <FuseTheme>
                            <FuseLayout
                                routes={routes}
                                toolbar={
                                    <MainToolbar/>
                                }
                                navbarHeader={
                                    <MainNavbarHeader/>
                                }
                                navbarContent={
                                    <MainNavbarContent/>
                                }
                                footer={
                                    <MainFooter/>
                                }
                            />
                        </FuseTheme>
                        <UecareLoadingMask/>
                        <PollingTool/>
                        <UecareErrorDialog/>
                    </FuseAuthorization>
                </Router>
            </ApiAuth>
        </Provider>
    </JssProvider>
    , document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js